var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 6.22222C7.36731 6.22222 8.8 4.82933 8.8 3.11111C8.8 1.39289 7.36731 0 5.6 0C3.83269 0 2.4 1.39289 2.4 3.11111C2.4 4.82933 3.83269 6.22222 5.6 6.22222Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.77778C13.3255 7.77778 14.4 6.73311 14.4 5.44444C14.4 4.15578 13.3255 3.11111 12 3.11111C10.6745 3.11111 9.6 4.15578 9.6 5.44444C9.6 6.73311 10.6745 7.77778 12 7.77778Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 13.2222C15.6418 13.2222 16 12.874 16 12.4444C15.9987 10.9615 15.13 9.60831 13.7603 8.9557C12.3906 8.30309 10.7583 8.46464 9.552 9.37222C7.94966 7.82051 5.54457 7.35815 3.45538 8.20022C1.3662 9.04228 0.00305944 11.0234 0 13.2222C0 13.6518 0.358172 14 0.8 14H10.4C10.8418 14 11.2 13.6518 11.2 13.2222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/contacts.3bd3a4ff9950ca2494818bc4efb41dec.svg";
export { ForwardRef as ReactComponent };